export default "__VITE_ASSET__gsVBuCNK__"